import { Controller } from 'stimulus'
import moment from "moment";
import lottie from "lottie-web";

export default class extends Controller {
  static targets = [
    'dateInput',
    'hourInput',
    'stringInput',
    'dropdownHours',
    'timeInputBox',
    'hourInputError',
    'confirmDate',
    'dummyForm',
    'confirmTzForm',
    'startDate',
    'timeZone',
    'timeZoneConfirmedAt',
    'timeZoneConfirmed',
    'showSelectedDate',
    'selectedDateDisplayBox',
    'themeInfo',
    'eventDurationInfo',
    'dateTimeSelection',
    'timeZoneSelection',
    'backArrow',
    'lottieContainer',
    'availabilityMessage'
  ]
  static values = { 
    themeName: String, 
    host: Boolean, 
    currency: String, 
    price: String, 
    participants: Number,
    skipDateCheck: Boolean,
    isEditing: Boolean,
    isHappySpider: Boolean
  }
  
  confetti = null;

  connect() {
    this.runCallbacks();

    // Select the node that will be observed for mutations
    var targetNode = this.timeInputBoxTarget;

    // Options for the observer (which mutations to observe)
    var config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    var callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(var mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.runCallbacks();
        }
      }
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback.bind(this));

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    // observe when picker comes onto screen
    let visibilityObserver = new IntersectionObserver(function() {
      this.scrollToSensibleTime();
    }.bind(this));
    visibilityObserver.observe(this.dateInputTarget);

    this.confetti = lottie.loadAnimation({
      container: this.lottieContainerTarget,
      renderer: 'svg',
      autoplay: false,
      loop: false,
      path: $(this.lottieContainerTarget).attr("path")
    });
  }

  runCallbacks() {
    this.determineButtonValidity();
    this.scrollToSensibleTime();
    this.preselectHour();
  }

  selectDate(event) {
    const selectedDate = event.currentTarget._flatpickr.selectedDates[0];
    const momentDate = moment(selectedDate)
    const tomorrow = moment().add(1, 'days')
    const today = moment()
    const isTomorrow = momentDate.format('dddd, D MMM') == tomorrow.format('dddd, D MMM')
    const isToday = momentDate.format('dddd, D MMM') == today.format('dddd, D MMM')

    if(isTomorrow && !this.skipDateCheckValue) {
      alert(this.isHappySpiderValue ? "It looks like you are trying to book an event for tomorrow. We can probably assist but please get in touch via phone +46840020904" : "It looks like you are trying to book an event for tomorrow. We can probably assist but please get in touch via webchat below.")
      this.validDateDeselected()
      return false
    } else if(isToday && !this.skipDateCheckValue) {
      alert("It looks like you are trying to book an event for today. Please choose a date in the future.")
      this.validDateDeselected()
      return false
    } else {
      this.validDateSelected(selectedDate, momentDate)
      return true
    }
  }

  validDateSelected(selectedDate, momentDate) {
    const formattedDate = momentDate.format('dddd, Do MMM');
    const timeZone = $('#order_configuration_time_zone').val();
    this.setTimeInput();

    // set up dummy form
    $(this.startDateTarget).val(selectedDate);
    $(this.timeZoneTarget).val(timeZone);

    if (this.hasConfirmDateTarget) {
      this.mutateWindow();
      this.scrollToSensibleTime();
    }

    $(this.showSelectedDateTarget).text(formattedDate);
    this.dummyFormTarget.requestSubmit();
  }

  validDateDeselected() {
    this.hourInputTarget.innerHTML = ''
    $(this.startDateTarget).val('');
    $(this.timeZoneTarget).val('');
    $(this.showSelectedDateTarget).text('');

    if (this.hasConfirmDateTarget) this.revertWindow();
    this.dummyFormTarget.requestSubmit();
  }

  selectTime(event) {
    // set time
    $(this.hourInputTarget)
      .text($(event.currentTarget).text())
      .removeClass('hidden')

    var isPartner = this.data.get("is-partner");

    $("#available-hours li").removeClass('selected-hour').addClass(isPartner == "true" ? 'text-indigo-500' : 'text-green-500')
    $(event.currentTarget).addClass('selected-hour').removeClass("text-green-500").removeClass("text-indigo-500")

    this.selectedNewTimezone = false;
    this.setTimeInput();
    this.determineButtonValidity();

    $(this.availabilityMessageTarget).removeClass('hidden')

    mixpanel.track('Selected Time', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'date': new Date($(this.startDateTarget).val()).toISOString(),
      'isEditing': this.isEditingValue
    });

    this.confetti.playSegments([0,150], true);
  }

  selectTimezone(event) {
    this.selectedNewTimezone = true;
    var timeZone = event.target.value;
    $('#order_configuration_time_zone').val(timeZone);
    $(this.timeZoneTarget).val(timeZone);
    this.dummyFormTarget.requestSubmit();
  }

  selectTimezoneConfirmed(event) {
    const timeZone = $('#order_configuration_time_zone').val();
    $(this.timeZoneConfirmedTarget).val(timeZone);
    this.confirmTzFormTarget.requestSubmit();
  }

  setTimeInput() {
    if (this.dateInputTarget.value.length) {
      this.stringInputTarget.value =
        this.dateInputTarget.value + ' ' + this.hourInputTarget.innerHTML
    } else {
      this.stringInputTarget.value = ''
    }
  }

  determineButtonValidity() {
    // 12:00 AM means time is yet unselected
    if ($(this.hourInputTarget).text() == "12:00 AM") {
      $(this.hourInputTarget).text('');
    }

    const validHour = this.checkHourValidity();
    const enabled =
      this.selectedNewTimezone == true ||
      (this.dateInputTarget.value.length > 0 &&
      this.hourInputTarget.innerHTML.length > 0 &&
      validHour === true);
    $(this.element)
      .find('.btn-submit')
      .toggleClass('disabled', !enabled)
      .attr('disabled', !enabled)
  }

  scrollToSensibleTime() {
    var dropdownTarget = $(this.dropdownHoursTarget);

    if (!this.hasSelectedValue || dropdownTarget.data('default') == 'true') {
      var selectedTime = this.hourInputTarget.innerHTML.trim();
      var openTimes = $(this.dropdownHoursTarget.getElementsByTagName('li'));
      var matchedTime;
      for (var i = 0; i <= openTimes.length - 1; i++) {
        if (openTimes[i].innerHTML === selectedTime) {
          matchedTime = openTimes[i];
          break;
        }
      }

      if (matchedTime) {
        var position = matchedTime.offsetTop;
        dropdownTarget[0].scrollTop = position;
      } else {
        var twelve = dropdownTarget.find('li[data-hour="12"]');
        if (twelve[0]) {
          var position = twelve[0].offsetTop;
          dropdownTarget[0].scrollTop = position;
        } else {
          var eight = dropdownTarget.find('li[data-hour="20"]');
          if (eight[0]) {
            var position = eight[0].offsetTop;
            dropdownTarget[0].scrollTop = position;
          }
        }
      }
    }
  }

  checkHourValidity() {
    var openTimes = $(this.dropdownHoursTarget.getElementsByTagName('li'));
    var open = [];

    for (var i = 0; i <= openTimes.length - 1; i++) {
      open.push(`${$(openTimes[i]).attr('data-hour')}:${$(openTimes[i]).attr('data-minute')}`);
    }

    var selectedTime = $(this.hourInputTarget).text().split(" ")[0];
    var dayHalf = $(this.hourInputTarget).text().split(" ")[1];

    if (!selectedTime || 0 === selectedTime.length) {
      return;
    } else if (selectedTime.length < 5) {
      selectedTime = `0${selectedTime}`;
    }

    if (dayHalf === "PM" && selectedTime.split(":")[0] != "12") {
      var hour = selectedTime.split(":")[0];
      selectedTime = `${Number(hour)+12}:${selectedTime.split(":")[1]}`;
    }

    if (open.includes(selectedTime)) {
      $(this.hourInputErrorTarget).addClass("hidden");
      $(this.hourInputTarget).removeClass("text-red-500");
      $(this.eventDurationInfoTarget).removeClass('hidden')
      return true;
    } else {
      $(this.hourInputErrorTarget).removeClass("hidden");
      $(this.hourInputTarget).addClass("text-red-500");
      $(this.eventDurationInfoTarget).addClass('hidden')
      return false;
    }
  }

  preselectHour() {
    var selectedTime = this.hourInputTarget.innerHTML.trim();
    var openTimes = $(this.dropdownHoursTarget.getElementsByTagName('li'));

    for (var i = 0; i <= openTimes.length - 1; i++) {
      if (openTimes[i].innerHTML === selectedTime) {
        $(openTimes[i]).addClass('selected-hour').removeClass("text-green-500");
      }
    }
  }

  mutateWindow() {
    $(this.selectedDateDisplayBoxTarget).removeClass('hidden');
    $(this.confirmDateTarget).addClass('hidden');
    $(this.themeInfoTarget).addClass("hidden");
    $(this.timeInputBoxTarget).removeClass("hidden");
  }

  revertWindow() {
    $(this.selectedDateDisplayBoxTarget).addClass('hidden');
    $(this.confirmDateTarget).removeClass('hidden');
    $(this.themeInfoTarget).removeClass("hidden");
    $(this.timeInputBoxTarget).addClass("hidden");
  }

  switchToTimezoneTab() {
    $(this.timeZoneSelectionTarget).removeClass('hidden')
    $(this.dateTimeSelectionTarget).addClass('hidden')
    $(this.backArrowTarget).removeClass('hidden')
  }

  switchToTimeSelectionTab() {
    $(this.timeZoneSelectionTarget).addClass('hidden')
    $(this.dateTimeSelectionTarget).removeClass('hidden')
    $(this.backArrowTarget).addClass('hidden')
    this.scrollToSensibleTime()
  }
}
